import { render, staticRenderFns } from "./MainContentSessions.vue?vue&type=template&id=51050e6a&scoped=true&lang=pug"
import script from "./MainContentSessions.vue?vue&type=script&lang=js"
export * from "./MainContentSessions.vue?vue&type=script&lang=js"
import style0 from "./MainContentSessions.vue?vue&type=style&index=0&id=51050e6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51050e6a",
  null
  
)

export default component.exports